import axios from 'axios';

const API_BASE_URL = '/api';

export const sendMessage = async (message, conversationId = null) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/chat/message`, {
      message,
      conversation_id: conversationId
    });
    return response.data;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const uploadTranscripts = async (transcripts) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/transcripts/upload`, transcripts);
    return response.data;
  } catch (error) {
    console.error('Error uploading transcripts:', error);
    throw error;
  }
};

export const getStats = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/stats`);
    return response.data;
  } catch (error) {
    console.error('Error getting stats:', error);
    throw error;
  }
};
